import React, {useCallback, useEffect, useRef, useState} from 'react'
import styles from 'components/Shared/CrudComponents/SimpleForm.module.css'
import * as Yup from 'yup'
import {useTranslation} from 'react-i18next'
import {FieldComponent} from 'components/Shared/FieldComponent'
import {Form} from 'formik'
import {FormColumn, FormRow, TitleBar} from 'components/Shared/CrudComponents'
import {
  DRIVER_CARRIER_READ,
  GLOBAL_CONFIGURATION_WRITE,
  useAuth,

} from 'context/auth'
import Sections from "../sections";
import {triggerFormSubmit} from "../../../utils/utils";
import {SuccessDialog} from "../../Shared/Dialogs";
import {editGlobalConfig, fetchGlobalConfig} from "../../../services";
import {useErrorHandling} from "../../../context/errorHandling";
import {FormikForm} from "../../Shared/FormikForm";
import {useNavigatePrevent} from "../../../context/navigatePrevent";

export const globalConfigSchema = Yup.object().shape({
  carrierVerificationValidityAfterDischarge: Yup.number().required('form.validation.required').min(1).integer(),
  carrierEmailsNumber: Yup.number().required('form.validation.required').min(1).integer(),
})

export function AdminPanelForm() {
  const {t} = useTranslation()
  const {hasAnyPrivileges} = useAuth()
  const formRef = useRef()
  const {handleError} = useErrorHandling()
  const {setNavigationUnlocked} = useNavigatePrevent()

  const [config, setConfig] = useState(null);
  const [editedDialogOpen, setEditedDialogOpen] = useState(false)
  const {setGlobalConfig} = useAuth()

  useEffect(() => {
    fetchGlobalConfig()
      .then(setConfig)
      .catch((error) => handleError(error));
  }, [setConfig, handleError]);

  const onFormSubmit = useCallback((values, onSuccess) =>
    editGlobalConfig({
      ...values,
    }).then((result) => onSuccess()
      .then(() => {
        setGlobalConfig(result)
        setEditedDialogOpen(true)})
      .catch(handleError)
    ).catch(error => handleError(error)
    ), [setEditedDialogOpen,setGlobalConfig, handleError])


  return <div>
    <TitleBar
      buttonLabel={t('common.submit')}
      onButtonClick={triggerFormSubmit(formRef)}
      title={t('adminPanel.form.title')}/>
    <SuccessDialog open={editedDialogOpen}
                   onClose={() => {
                     setEditedDialogOpen(false)
                     setNavigationUnlocked(history => history.push('/admin-panel'))
                   }} content={t('notifications.success.updatedAdminPanel')}/>
    {config && <div className={styles.containerRow}>
      <FormikForm
        innerRef={formRef}
        initialValues={{
          carrierVerificationValidityAfterDischarge: config.carrierVerificationValidityAfterDischarge,
          carrierEmailsNumber: config.carrierEmailsNumber
        }}
        validationSchema={globalConfigSchema}
        onSubmit={onFormSubmit}>
        <Form>
          <FormRow>
            <FormColumn section={Sections.Orders}
                        disabled={!hasAnyPrivileges([DRIVER_CARRIER_READ, GLOBAL_CONFIGURATION_WRITE])}
            >
              <small className={"pb-1"}>
                {t("adminPanel.details.verificationValidAfterDischarge.desc")}
              </small>
              <FieldComponent type={'number'} fieldName={'carrierVerificationValidityAfterDischarge'}
                              label={'adminPanel.details.verificationValidAfterDischarge.label'}
                              inputProps={{min: 1}}
                              />
            </FormColumn>
          </FormRow>
          <FormRow>
            <FormColumn section={Sections.CarrierEmails}
                        disabled={!hasAnyPrivileges([DRIVER_CARRIER_READ, GLOBAL_CONFIGURATION_WRITE])}
            >
              <small className={"pb-1"}>
                {t("adminPanel.details.carrierEmailsNumber.desc")}
              </small>
              <FieldComponent type={'number'} fieldName={'carrierEmailsNumber'}
                              label={'adminPanel.details.carrierEmailsNumber.label'}
                              inputProps={{min: 1}}
              />
            </FormColumn>
          </FormRow>
        </Form>
      </FormikForm>
    </div>}
  </div>
}
